import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[iaBlockCopyPaste]',
  standalone: true,
})
export class BlockCopyPasteDirective {
  @HostListener('paste', ['$event']) public blockPaste(e: ClipboardEvent): void {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) public blockCopy(e: ClipboardEvent): void {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) public blockCut(e: ClipboardEvent): void {
    e.preventDefault();
  }
}
